import {ALL_LANGUAGES} from "./all_languages";
import {SUPPORTED_LANGUAGES} from "../../tools/languages";

export function getAllUnsupportedLanguages(): string[] {
  const supportedCodes = SUPPORTED_LANGUAGES.map(language => language.code.toLowerCase());
  return ALL_LANGUAGES.filter(code => !supportedCodes.includes(code.toLowerCase()));
}
